import { MdEmail, MdGroups, MdPhone, MdPlace, MdStickyNote2, MdTaskAlt } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { hoyLocal, sumarDias } from "utils/fechasLocales";

// Mismo orden que TIPOS en actividadesController.js. Es el respaldo mientras
// llega el catálogo; el servidor manda.
export const TIPOS_POR_DEFECTO = [
  { clave: "LLAMADA", nombre: "Llamada" },
  { clave: "REUNION", nombre: "Reunión" },
  { clave: "VISITA", nombre: "Visita" },
  { clave: "CORREO", nombre: "Correo" },
  { clave: "WHATSAPP", nombre: "WhatsApp" },
  { clave: "TAREA", nombre: "Tarea" },
  { clave: "NOTA", nombre: "Nota" },
];

export const ICONO_TIPO = {
  LLAMADA: MdPhone,
  REUNION: MdGroups,
  VISITA: MdPlace,
  CORREO: MdEmail,
  WHATSAPP: FaWhatsapp,
  TAREA: MdTaskAlt,
  NOTA: MdStickyNote2,
};

export const COLOR_TIPO = {
  LLAMADA: "blue",
  REUNION: "purple",
  VISITA: "orange",
  CORREO: "cyan",
  WHATSAPP: "green",
  TAREA: "gray",
  NOTA: "yellow",
};

export const nombreTipo = (clave, tipos = TIPOS_POR_DEFECTO) =>
  tipos.find((tipo) => tipo.clave === clave)?.nombre || clave;

export const estaVencida = (actividad, hoy = hoyLocal()) =>
  Boolean(!actividad.completada && actividad.fecha && actividad.fecha < hoy);

export const GRUPOS_PENDIENTES = [
  { clave: "vencidas", titulo: "Vencidas", color: "red" },
  { clave: "hoy", titulo: "Hoy", color: "blue" },
  { clave: "manana", titulo: "Mañana", color: "purple" },
  { clave: "semana", titulo: "Próximos 7 días", color: "gray" },
  { clave: "despues", titulo: "Más adelante", color: "gray" },
];

/**
 * Reparte las pendientes en los grupos de "Mis tareas". Llegan ordenadas por
 * fecha y hora desde el servidor y conservan ese orden dentro de cada grupo.
 */
export const agruparPendientes = (actividades, hoy = hoyLocal()) => {
  const manana = sumarDias(hoy, 1);
  const finDeSemana = sumarDias(hoy, 7);
  const grupos = Object.fromEntries(GRUPOS_PENDIENTES.map((grupo) => [grupo.clave, []]));

  for (const actividad of actividades) {
    if (actividad.completada) continue;
    const fecha = actividad.fecha || "";
    if (fecha < hoy) grupos.vencidas.push(actividad);
    else if (fecha === hoy) grupos.hoy.push(actividad);
    else if (fecha === manana) grupos.manana.push(actividad);
    else if (fecha <= finDeSemana) grupos.semana.push(actividad);
    else grupos.despues.push(actividad);
  }
  return grupos;
};

/** Cifras de la cabecera: lo que el asesor tiene que mirar primero. */
export const contarPendientes = (actividades, hoy = hoyLocal()) => {
  const grupos = agruparPendientes(actividades, hoy);
  return {
    vencidas: grupos.vencidas.length,
    hoy: grupos.hoy.length,
    proximos7: grupos.manana.length + grupos.semana.length,
  };
};
